import styled from 'styled-components'

const IconWrap = ({ handleClick = null, children, off = false, message = '' }) => {

  // console.log(message, off);

  return (
    <Wrap $off={off} onClick={handleClick} title={message}>
      {children}
      <p>{message}</p>
    </Wrap>
  )
}

export default IconWrap

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  gap: 6px;
  cursor: pointer;
  opacity: ${(props) => (props.$off ? '0.25' : '1')};
  pointer-events: ${(props) => (props.$off ? 'none' : 'auto')};
  padding: 4px;

  & p {
    font-size: 11px;
    font-family: var(--button-font);
    text-transform: var(--button-case);
    color: ${(props) => (props.$off ? 'transparent' : 'var(--icon-color)')};
    margin-block: 0;
    max-width: 5ch;
    text-align: center;
    line-height: 1.2;
    font-weight: 700;
  }
  &:hover p {
    color: var(--icon-color-hover);
  }

 & svg {
    width: 40px;
    height: 40px;
    transition: 0.2s all;
    pointer-events: ${(props) => (props.$off ? 'none' : 'auto')};
    fill: var(--heading-color);
  opacity: ${(props) => (props.$off ? '0.15' : '1')};
     
  }
  
  &:hover svg {
    fill: var(--icon-color-hover);
  }
`

